import { useEffect, useRef, useState } from "react";

// Visibility-aware polling: refreshes on an interval while the tab is visible,
// and immediately when the tab regains focus or the network comes back.
export function useLiveRefresh(refresh, ms = 15000) {
  const ref = useRef(refresh);
  ref.current = refresh;
  const [at, setAt] = useState(() => Date.now());
  useEffect(() => {
    let busy = false;
    const run = async () => {
      if (busy || document.hidden) return;
      busy = true;
      try { await ref.current(); setAt(Date.now()); } catch { /* keep last good data */ } finally { busy = false; }
    };
    const onVisible = () => { if (!document.hidden) run(); };
    const iv = setInterval(run, ms);
    document.addEventListener("visibilitychange", onVisible);
    window.addEventListener("focus", onVisible);
    window.addEventListener("online", run);
    return () => {
      clearInterval(iv);
      document.removeEventListener("visibilitychange", onVisible);
      window.removeEventListener("focus", onVisible);
      window.removeEventListener("online", run);
    };
  }, [ms]);
  return at;
}

export const ago = (ts) => {
  const s = Math.max(0, Math.round((Date.now() - new Date(ts).getTime()) / 1000));
  if (s < 10) return "just now";
  if (s < 60) return `${s}s ago`;
  if (s < 3600) return `${Math.round(s / 60)} min ago`;
  if (s < 86400) return `${Math.round(s / 3600)} h ago`;
  return `${Math.round(s / 86400)} d ago`;
};

export function UpdatedAgo({ at, testid = "live-updated" }) {
  const [, tick] = useState(0);
  const [online, setOnline] = useState(navigator.onLine);
  useEffect(() => {
    const iv = setInterval(() => tick((n) => n + 1), 5000);
    const on = () => setOnline(true), off = () => setOnline(false);
    window.addEventListener("online", on); window.addEventListener("offline", off);
    return () => { clearInterval(iv); window.removeEventListener("online", on); window.removeEventListener("offline", off); };
  }, []);
  return (
    <span className="inline-flex items-center gap-1.5 font-mono-data text-[11px] text-slate-500" data-testid={testid}>
      <span className={`h-1.5 w-1.5 rounded-full ${online ? "bg-emerald-400" : "bg-red-500"}`} />
      {online ? `Live · updated ${ago(at)}` : "Offline — will refresh when reconnected"}
    </span>
  );
}
